import { useEffect, useState } from 'react'

const generateStarBoxShadow = (count) => {
  const shadows = []
  const w = window.screen.width * 2 || 4000
  for (let i = 0; i < count; i++) {
    const x = Math.floor(Math.random() * w)
    const y = Math.floor(Math.random() * 2000)
    shadows.push(`${x}px ${y}px #FFF`)
  }
  return shadows.join(', ')
}

export default function CosmicParallaxBg({ children, className = '' }) {
  const [smallStars, setSmallStars] = useState('')
  const [mediumStars, setMediumStars] = useState('')
  const [bigStars, setBigStars] = useState('')

  useEffect(() => {
    setSmallStars(generateStarBoxShadow(1400))
    setMediumStars(generateStarBoxShadow(400))
    setBigStars(generateStarBoxShadow(200))
  }, [])

  return (
    <div className={`cosmic-root ${className}`}>
      <style>{`
        .cosmic-root {
          position: relative;
          width: 100%;
          min-height: 100vh;
          background: radial-gradient(ellipse at bottom, #0d1b2e 0%, #050a10 60%, #000000 100%);
          overflow: hidden;
        }

        /* Star layers */
        .cosmic-stars-sm,
        .cosmic-stars-md,
        .cosmic-stars-lg {
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 50%;
          animation: animStar linear infinite;
        }
        .cosmic-stars-sm {
          width: 1px;
          height: 1px;
          animation-duration: 50s;
          opacity: 0.8;
        }
        .cosmic-stars-md {
          width: 2px;
          height: 2px;
          animation-duration: 100s;
          opacity: 0.6;
        }
        .cosmic-stars-lg {
          width: 3px;
          height: 3px;
          animation-duration: 150s;
          opacity: 0.5;
        }

        @keyframes animStar {
          from { transform: translateY(0px); }
          to   { transform: translateY(-2000px); }
        }

        /* Earth horizon */
        .cosmic-earth {
          position: absolute;
          bottom: -780px;
          left: 50%;
          transform: translateX(-50%);
          width: 2800px;
          height: 900px;
          border-radius: 50%;
          background: radial-gradient(ellipse at 50% 30%, #0d1b2e 0%, #060d18 60%, #020609 100%);
          z-index: 1;
        }

        .cosmic-horizon {
          position: absolute;
          bottom: -770px;
          left: 50%;
          transform: translateX(-50%);
          width: 2840px;
          height: 920px;
          border-radius: 50%;
          z-index: 0;
        }

        .cosmic-glow {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow:
            0 -6px 40px 6px rgba(30, 120, 200, 0.35),
            0 -2px 16px 2px rgba(0, 180, 255, 0.18);
        }

        /* Content sits above stars and earth */
        .cosmic-content {
          position: relative;
          z-index: 10;
          width: 100%;
        }
      `}</style>

      {/* Star layers */}
      <div className="cosmic-stars-sm" style={{ boxShadow: smallStars }} />
      <div className="cosmic-stars-md" style={{ boxShadow: mediumStars }} />
      <div className="cosmic-stars-lg" style={{ boxShadow: bigStars }} />

      {/* Horizon glow + Earth arc */}
      <div className="cosmic-horizon">
        <div className="cosmic-glow" />
      </div>
      <div className="cosmic-earth" />

      {/* Hero content */}
      <div className="cosmic-content">
        {children}
      </div>
    </div>
  )
}
